
class StorageClient {
  async storeFiles(file) {
    const formData = new FormData()
    formData.append('file', file)
    const response = await fetch(`${process.env.REACT_APP_services_api}uploadIPFS`, {
      method: 'POST',
      body: formData,
    })
    const data = await response.json()
    const cid = data.cid
    const imageURI = `https://ipfs.filebase.io/ipfs/${cid}`
    return imageURI
  }
}

export default StorageClient
